/** @module csi/action/ApplySort */
define([
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/xml"
], function(def,Action,ActionFactory,xml) {

	return ActionFactory.declare("tableApplySort", Action, {
		constructor: function() {
			this.m_id = "TableApplySort";
			this.setBaseRights(null, xml.RIGHT_WRITE);
			this.m_typeControl = def.ACTION_ICON;
			this.m_class = "iconApplySort";
		},
		
		/**
		 * Disable if first level of view is filtered or if custom view sort attribute is set don't enable the widget
		 */
		hasAccess: function(ctx) {
			var	qr = ctx.view.getQueryResult(null, true);
			return qr && !qr.isFiltered() && !ctx.view.get("customViewSortExists") && this.inherited(arguments);
		},
		
		/**
		 * Validate that action is available based on view configuration
		 */
		validate: function(ctx) {
			var	r = ctx.view.relRoot;
			return r && r.bOrdered && r.getAction("MoveUp") && !ctx.bPrint && (!ctx.fd || ctx.fd.m_bEditable) && ctx.view.canSort();
		}
	});
});